export const removeAccents = (text) => {
    let textWithoutAccents = text;
    textWithoutAccents = textWithoutAccents.replace(/([áâãà])/g, 'a');
    textWithoutAccents = textWithoutAccents.replace(/([éêè])/g, 'e');
    textWithoutAccents = textWithoutAccents.replace(/([íîì])/g, 'i');
    textWithoutAccents = textWithoutAccents.replace(/([óôõò])/g, 'o');
    textWithoutAccents = textWithoutAccents.replace(/([úûù])/g, 'u');
    textWithoutAccents = textWithoutAccents.replace(/([ÁÂÃÀ])/g, 'A');
    textWithoutAccents = textWithoutAccents.replace(/([ÉÊÈ])/g, 'E');
    textWithoutAccents = textWithoutAccents.replace(/([ÍÎÌ])/g, 'I');
    textWithoutAccents = textWithoutAccents.replace(/([ÓÔÕÒ])/g, 'O');
    textWithoutAccents = textWithoutAccents.replace(/([ÚÛÙ])/g, 'U');
    textWithoutAccents = textWithoutAccents.replace(/([ç])/g, 'c');
    textWithoutAccents = textWithoutAccents.replace(/([Ç])/g, 'C');
    return textWithoutAccents;
}